import PropTypes from 'prop-types'

import { FormatPrice, PrefixPrice } from 'reactUtils/Price'

import * as S from './styled'

const PriceInfo = ({
  packaging,
  packagingCount,
  translatedUnit,
  quantity,
  price: { from, to, total }
}) => {
  return (
    <S.PriceInfo>
      { from && from !== to &&
        <S.UnitPrice data-testid="from" decoration={true}>
          <FormatPrice quantity={packaging} unit={translatedUnit} price={from} />
        </S.UnitPrice>
      }
      <S.UnitPrice data-testid="to">
        <PrefixPrice packaging={packaging} packagingCount={1} />
        <FormatPrice quantity={packaging} unit={translatedUnit} price={to} />
      </S.UnitPrice>
      <S.TotalPrice data-testid="total">
        <PrefixPrice packaging={quantity} packagingCount={packagingCount} />
        <FormatPrice quantity={quantity} unit={translatedUnit} price={total} />
      </S.TotalPrice>
    </S.PriceInfo>
  )
}

PriceInfo.propTypes = {
  packaging: PropTypes.number.isRequired,
  packagingCount: PropTypes.number.isRequired,
  translatedUnit: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  price: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,
  packagingUnitLabels: PropTypes.shape({
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired
  }).isRequired
}

PriceInfo.defaultProps = {
  packagingUnitLabels: {
    singular: '',
    plural: ''
  }
}

export default PriceInfo
